import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  body {
      margin: 0;
      padding: 20px 40px;
      font-family: 'Open Sans Condensed', sans-serif;
      
      @media screen and (max-width: 800px) {
        padding: 10px;
      }
  }

  a {
      text-decoration: none;
      color: black;    
  }

  * {
      box-sizing: border-box;
  }

  .App {
      text-align: center;
    }
    
  .App-logo {
    height: 40vmin;
    pointer-events: none;
  }
  
  @media (prefers-reduced-motion: no-preference) {
    .App-logo {
      animation: App-logo-spin infinite 20s linear;
    }
  }
  
  .App-header {
    background-color: #282c34;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: calc(10px + 2vmin);
    color: white;
  }
  
  .App-link {
    color: #61dafb;
  }
  
  @keyframes App-logo-spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  } 
`;

export default GlobalStyle;